import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isLoggedIn: boolean;
  userId: string | null;
}

const initialState: AuthState = {
  isLoggedIn: !!localStorage.getItem("loginemail"),
  userId: localStorage.getItem("loginemail") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      state.isLoggedIn = true;
      state.userId = action.payload;
      localStorage.setItem("loginemail", action.payload);
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.userId = null;
      localStorage.removeItem("loginemail");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
